import { useContext } from 'react';
import { ProjectContext, ProjectContextType } from '../contexts/project_context';

const useProject = () => {
    return useContext(ProjectContext) as ProjectContextType;
};

export default useProject;
